<div fxLayout="column" style="height: 100%">
   <div class="k-form-field sam-full-width sam-margin">
      <samweb-searchbar
         fxFlex="1 1 auto"
         [searchValue$]="agentSearchValue$"
         (searchValueChangedDebounced)="searchTextChanged($event)"
      >
      </samweb-searchbar>

      <samweb-grid-filter
         [availableValues$]="availableAgentStatusFilters$"
         filterId="agentStatusFilter"
         [brickInstanceId]="brickInstanceId"
      ></samweb-grid-filter>
      <button
         (click)="removeAllFilters()"
         class="button-spacing"
         kendoButton
         kendoTooltip
         [title]="'common.clear_all_filters' | translate"
      >
         <fa-icon [icon]="clearFilterIcon" [fixedWidth]="true"></fa-icon>
      </button>
   </div>

   <ng-template #tooltipTemplate let-anchor>
      <span>{{ anchor.nativeElement.innerText }}</span>
   </ng-template>
   <div
      class="sam-full-height sam-auto-overflow container"
      [ngClass]="{ 'sam-grid-loading': (agentList$ | async).length === 0 }"
      fxLayout="column"
   >
      <kendo-grid
         samwebPersistKendoGrid
         samwebVirtualScrollKendoGrid
         kendoTooltip
         [columnMenu]="true"
         [virtualScrollData]="agentList$ | async"
         [virtualScrollWasSearchExecuted]="isSearchExecuting$ | async"
         [reorderable]="true"
         [resizable]="true"
         [sortable]="true"
         [sort]="sortDescription$ | async"
         (sortChange)="sortChange($event)"
         [selectable]="{
            mode: 'single'
         }"
         kendoGridSelectBy="userId"
         [selectedKeys]="selectedKeys$ | async"
         (selectionChange)="selectionChanged($event)"
         fxFlex="1 1 auto"
         showOn="none"
         [tooltipTemplate]="tooltipTemplate"
         #cellTooltipDirective="kendoTooltip"
         filter=".k-grid td"
         (mouseover)="showTooltip($event)"
         (mouseout)="hideTooltip()"
         (dblclick)="onRowDoubleClick($event)"
      >
         <kendo-grid-column
            [title]="
               'wa_agentlist_status'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.agent_state'
                  | async
            "
            field="userStatus.type"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-agent-status [statusInfo]="dataItem.userStatus"></samweb-agent-status>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_name' | customColumnName: 'brick.brick_definitions.agent_list.columns.agent_name' | async
            "
            field="displayName"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <div innerHtml="{{ dataItem.displayName | highlightText$: agentSearchValue$:true | async }}"></div>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_email' | customColumnName: 'brick.brick_definitions.agent_list.columns.agent_email' | async
            "
            field="email"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <div innerHtml="{{ dataItem.email | highlightText$: agentSearchValue$:true | async }}"></div>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_dn' | customColumnName: 'brick.brick_definitions.agent_list.columns.agent_dn' | async
            "
            field="directoryNumber"
         >
            <ng-template kendoGridCellTemplate let-dataItem *samwebVar="selectedKeys$ | async as selectedKeys">
               <div
                  class="callable"
                  innerHtml="{{ dataItem.directoryNumber | highlightText$: agentSearchValue$:true | async }}"
                  (click)="selectedKeys.indexOf(dataItem.userId) > -1 && call(dataItem.directoryNumber)"
               ></div>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_peer_number'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.peer_id'
                  | async
            "
            field="peerNumber"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.peerNumber">
                  {{ dataItem.peerNumber }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_peer_name'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.peer_name'
                  | async
            "
            field="peerName"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.peerNumber !== 'anonymous'; else anonymousCaller">
                  {{ dataItem.peerName }}
               </ng-container>
               <ng-template #anonymousCaller>
                  {{ 'common.calling.unknown_number' | translate }}
               </ng-template>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_device'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.acd_extension'
                  | async
            "
            field="device"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.device">
                  {{ dataItem.device | acdCurrentDevice$: dataItem.userId | acdLineToDisplayNumber$ | async }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_duration'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.call_duration'
                  | async
            "
            field="duration"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.callTime">
                  {{ dataItem.callTime | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="'wa_agentlist_tta' | customColumnName: 'brick.brick_definitions.agent_list.columns.tta' | async"
            field="callTime"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.callTimeOffered && dataItem.callTime">
                  {{
                     dataItem.callTime
                        | toUTCMoment$
                        | async
                        | amDifference: (dataItem.callTimeOffered | toUTCMoment$ | async):'ms'
                        | durationToText$
                        | async
                  }}
               </ng-container>
               <ng-container *ngIf="dataItem.callTimeOffered && !dataItem.callTime">
                  {{ dataItem.callTimeOffered | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_ici' | customColumnName: 'brick.brick_definitions.agent_list.columns.call_ici' | async
            "
            field="ici"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container>
                  {{ dataItem.ici | iciText }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_agentlist_memo' | customColumnName: 'brick.brick_definitions.agent_list.columns.call_memo' | async
            "
            field="memo"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <ng-container *ngIf="dataItem.memo">
                  {{ dataItem.memo }}
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="presenceStatus"
            [title]="
               'wa_agentlist_presence_status'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.presence_status'
                  | async
            "
            [sortable]="false"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status
                  [presenceId]="dataItem?.directoryEntryPresence?.presenceId"
                  [presenceTypeValue]="dataItem?.directoryEntryPresence?.presenceType"
               ></samweb-presence-status>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="presenceStatusNote"
            [title]="
               'wa_agentlist_presence_status_note'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.presence_status_note'
                  | async
            "
            [sortable]="false"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status-note
                  [presenceId]="dataItem?.directoryEntryPresence?.presenceId"
                  [presenceTypeValue]="dataItem?.directoryEntryPresence?.presenceType"
               ></samweb-presence-status-note>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="presenceStatusForwardDestination"
            [title]="
               'wa_agentlist_presence_status_forward_destination'
                  | customColumnName: 'brick.brick_definitions.agent_list.columns.presence_status_forward_destination'
                  | async
            "
            [sortable]="false"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status-forward-destination
                  [presenceId]="dataItem?.directoryEntryPresence?.presenceId"
                  [presenceTypeValue]="dataItem?.directoryEntryPresence?.presenceType"
               ></samweb-presence-status-forward-destination>
            </ng-template>
         </kendo-grid-column>

         <ng-template kendoGridNoRecordsTemplate>
            <samweb-grid-wait-for-data
               [brickInstanceIdFroLongRunningCheck]="brickInstanceId"
            ></samweb-grid-wait-for-data>
         </ng-template>
      </kendo-grid>
      <div *ngIf="(activeFilters$ | async).length > 0" class="agent-list-filter">
         <fa-icon [icon]="statusBarFilterIcon"></fa-icon>
         <span *ngFor="let agentStatusFilter of activeFilters$ | async; last as isLast">
            {{ agentStatusFilter.translationKey | translate }}<span *ngIf="!isLast">, </span>
         </span>
      </div>
   </div>
</div>
